import { render } from "./Search.vue?vue&type=template&id=6d0b7912&bindings={}"
import script from "./Search.vue?vue&type=script&lang=ts"
export * from "./Search.vue?vue&type=script&lang=ts"
script.render = render

export default script